import React from 'react';

const About = () => {
  const features = [
    { icon: '👨‍🍳', title: 'Expert Chefs', desc: 'Trained professionals' },
    { icon: '🥬', title: 'Fresh Ingredients', desc: 'Daily sourced' },
    { icon: '🏆', title: 'Award Winning', desc: 'Multiple accolades' },
    { icon: '❤️', title: 'Made with Love', desc: 'Every single dish' },
  ];

  return (
    <section id="about" style={styles.section}>
      <div style={styles.container}>
        <div style={styles.content}>
          <div style={styles.imageSection}>
            <div style={styles.mainImage}>
              <span style={styles.mainImageEmoji}>🍽️</span>
            </div>
            <div style={styles.experienceBadge}>
              <div style={styles.badgeNumber}>15+</div>
              <div style={styles.badgeText}>Years of<br/>Excellence</div>
            </div>
            <div style={styles.smallImage}>
              <span style={styles.smallImageEmoji}>👨‍🍳</span>
            </div>
          </div>
          
          <div style={styles.textSection}>
            <span style={styles.label}>OUR STORY</span>
            <h2 style={styles.heading}>We Create Unforgettable<br/>Dining Experiences</h2>
            <p style={styles.text}>
              Since 2010, Delicious Resto has been the premier destination for food lovers 
              seeking authentic flavors and exceptional service. Our journey began with a 
              simple vision: to bring people together through the universal language of food.
            </p>
            <p style={styles.text}>
              Every dish we serve is a masterpiece, crafted with precision using time-honored 
              recipes passed down through generations, combined with innovative culinary techniques. 
              We source only the finest ingredients to ensure every bite exceeds your expectations.
            </p>
            
            <div style={styles.featuresGrid}>
              {features.map((feature, index) => (
                <div key={index} style={styles.featureCard}>
                  <span style={styles.featureIcon}>{feature.icon}</span>
                  <div>
                    <div style={styles.featureTitle}>{feature.title}</div>
                    <div style={styles.featureDesc}>{feature.desc}</div>
                  </div>
                </div>
              ))}
            </div>
            
            <button style={styles.button}>
              Learn More About Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: '6rem 2rem',
    backgroundColor: 'var(--white)',
  },
  container: {
    maxWidth: '1400px',
    margin: '0 auto',
  },
  content: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '5rem',
    alignItems: 'center',
  },
  imageSection: {
    position: 'relative',
    height: '600px',
  },
  mainImage: {
    width: '85%',
    height: '500px',
    backgroundColor: 'var(--cream)',
    borderRadius: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '6rem',
    boxShadow: '0 20px 60px rgba(0,0,0,0.1)',
  },
  mainImageEmoji: {
    fontSize: '6rem',
  },
  experienceBadge: {
    position: 'absolute',
    top: '20%',
    right: '0',
    backgroundColor: 'var(--maroon)',
    color: 'var(--white)',
    padding: '2rem',
    borderRadius: '20px',
    textAlign: 'center',
    boxShadow: '0 15px 40px rgba(139, 46, 59, 0.3)',
  },
  badgeNumber: {
    fontSize: '3rem',
    fontWeight: '800',
    marginBottom: '0.5rem',
  },
  badgeText: {
    fontSize: '1rem',
    fontWeight: '600',
    lineHeight: '1.3',
  },
  smallImage: {
    position: 'absolute',
    bottom: '0',
    right: '10%',
    width: '200px',
    height: '200px',
    backgroundColor: 'var(--white)',
    borderRadius: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '4rem',
    boxShadow: '0 15px 40px rgba(0,0,0,0.15)',
  },
  smallImageEmoji: {
    fontSize: '4rem',
  },
  textSection: {
    padding: '2rem 0',
  },
  label: {
    color: 'var(--maroon)',
    fontSize: '0.9rem',
    fontWeight: '700',
    letterSpacing: '2px',
    marginBottom: '1rem',
    display: 'block',
  },
  heading: {
    fontSize: '3rem',
    fontWeight: '800',
    color: 'var(--dark)',
    marginBottom: '1.5rem',
    lineHeight: '1.2',
    letterSpacing: '-1px',
  },
  text: {
    fontSize: '1.1rem',
    lineHeight: '1.8',
    color: '#666',
    marginBottom: '1.5rem',
  },
  featuresGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '1.5rem',
    margin: '2.5rem 0',
  },
  featureCard: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    padding: '1.2rem',
    backgroundColor: 'var(--cream)',
    borderRadius: '15px',
    transition: 'transform 0.3s ease',
  },
  featureIcon: {
    fontSize: '2.5rem',
  },
  featureTitle: {
    fontSize: '1.1rem',
    fontWeight: '700',
    color: 'var(--dark)',
    marginBottom: '0.2rem',
  },
  featureDesc: {
    fontSize: '0.85rem',
    color: '#666',
  },
  button: {
    backgroundColor: 'var(--maroon)',
    color: 'var(--white)',
    padding: '1.2rem 2.5rem',
    fontSize: '1rem',
    border: 'none',
    borderRadius: '50px',
    cursor: 'pointer',
    fontWeight: '700',
    transition: 'all 0.3s ease',
    boxShadow: '0 10px 30px rgba(139, 46, 59, 0.3)',
  },
};

export default About;